export default __webpack_public_path__ + "static/media/o.be0c7c76.svg";